import { render, staticRenderFns } from "./TheProductDetailsZoom.vue?vue&type=template&id=2a14980a&"
import script from "./TheProductDetailsZoom.vue?vue&type=script&lang=js&"
export * from "./TheProductDetailsZoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/lucia/proyectos/byl_salesforce/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a14980a')) {
      api.createRecord('2a14980a', component.options)
    } else {
      api.reload('2a14980a', component.options)
    }
    module.hot.accept("./TheProductDetailsZoom.vue?vue&type=template&id=2a14980a&", function () {
      api.rerender('2a14980a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/TheProductDetailsZoom.vue"
export default component.exports